import tripEvents from './../config/events.constant';
import templateMyModalContent from './../templates/my-modal-content.html';
import {flightStates} from '../../flights/flights-routes';
import {SIZE_LARGE} from '../../common/modal/modal-service';
import TRIP_ITEMS from './../config/items.constant';
import actionTripMessages from './../config/actionTripMessages.constant';


export default function TripBookingModal(
    $rootScope,
    $uibModal,
    $state,
    tripFactory,
    tripOptionsService,
    l10nService,
    tripBookingService
) {
    'ngInject';

    const FAILED_HOLDING_STATUSES = [
        tripOptionsService.HOLDING_STATUS.Failed,
        tripOptionsService.HOLDING_STATUS.NoLongerAvailable,
    ];

    const FAILED_BOOKING_STATUSES = [
        tripOptionsService.BOOKING_STATUS.Failed,
        tripOptionsService.BOOKING_STATUS.Duplicate,
        tripOptionsService.BOOKING_STATUS.NoLongerAvailable,
    ];

    const getHoldRedirectUrl = getFunctionForGettingRedirectStateByBookingItems(FAILED_HOLDING_STATUSES);

    Object.assign(this, {
        openBookModal,
        openHoldModal,
    });

    function openBookModal(response, scope, tripId, tripDetails) {
        const modalData = confirmData(response, tripId, tripDetails);
        openModal(modalData, scope);
    }

    function openHoldModal(response, scope) {
        if (response.IsFullyBooked) {
            $rootScope.$broadcast(tripEvents.TRIP_FINISH_HOLD);
            scope.isBook = false;
            scope.isHold = false;
        }

        const modalData = holdData(response, scope);
        openModal(modalData, scope);
    }

            function openModal(modalData, scope) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    template: templateMyModalContent,
                    size: SIZE_LARGE,
                    controller: 'ModalController',
                    backdrop: 'static',
                    resolve: {
                        modalData: () => modalData,
                    },
                });

                modalInstance
                    .result
                    .then((state) => {
                        scope.confirmBookDisabled = false;
                        if (!state) {
                            return;
                        }
                        $rootScope.$broadcast(tripEvents.TRIP_FINISH_BOOK);
                        if (_.isString(state)) {
                            $state.go(state);
                        } else if (_.isObject(state) && state.url) {
                            $state.go(state.url, state.params);
                        }
                    }, () => {
                        scope.cancelProcess();
                        scope.confirmBookDisabled = false;
                    });
            }

            function holdData(response, scope) { // eslint-disable-line
                const bookingResponses = response.BookingResponses;
                const status = tripOptionsService.HOLDING_STATUS;
                const modal = {
                        title: l10nService.localize('Hold status'),
                        redirectTo: 'main.flights.roundtrip',
                    };

                if (response.IsFullyBooked) {

                    /**
                     * SUCCESS Handler
                     */
                    modal.body = _.template(l10nService.localize(actionTripMessages.Holding.Success))({
                        id: scope.tripDetails.Id,
                    });
                } else {

                    /**
                     * FAIL Handlers
                     */
                    modal.title = l10nService.localize('Technical issue');
                    modal.body = l10nService.localize(actionTripMessages.Holding.AllFailed);

                    //1. FAIL: Technical issue - Some items cannot be booked due to technical fail
                    if (!bookingResponses || issuesChecker(bookingResponses, status.Failed)) {
                        modal.body = l10nService.localize(actionTripMessages.Holding.AllFailed);
                    }
                    if (bookingResponses) {
                        //2. FAIL: Availability issues – Some items cannot be booked due to no longer being available
                        if (bookingResponses && issuesChecker(bookingResponses, status.NoLongerAvailable)) {
                            modal.body = l10nService.localize(actionTripMessages.Holding.AllNoLongerAvailable);
                        } else if (bookingResponses && _.some(bookingResponses, {BookingStatus: status.NoLongerAvailable})) {
                            modal.body = l10nService.localize(actionTripMessages.Holding.SomeNoLongerAvailable.part1) + l10nService.localize(actionTripMessages.Holding.SomeNoLongerAvailable.part2);
                            modal.items = tripFactory.findItems(status.NoLongerAvailable, response, scope.tripDetails);
                        } else if (bookingResponses && _.some(bookingResponses, {BookingStatus: status.NoLongerAvailable})) {
                            modal.body = l10nService.localize(actionTripMessages.Holding.SomeNoLongerAvailable.part1) + l10nService.localize(actionTripMessages.Holding.SomeNoLongerAvailable.part2);
                            modal.items = tripFactory.findItems(status.NoLongerAvailable, response, scope.tripDetails);
                        }
                        modal.redirectTo = getHoldRedirectUrl(bookingResponses || []);
                    }
                }
                return modal;
            }


            function confirmData(response, tripId, tripDetails) {
                if (tripBookingService.isBookingSucceeded(response)) {
                    return tripBookingService.renderSuccessMessage(response, tripId, tripDetails);
                }

                if (tripBookingService.isThereProblemWithPayment(response)) {
                    return tripBookingService.renderFailedPaymentModal(response);
                }

                if (tripBookingService.isTripFailedWithTolerance(response)) {
                    return tripBookingService.renderToleranceFail(response, tripId);
                }

                const getBookRedirectUrl = getFunctionForGettingRedirectStateByBookingItems(FAILED_BOOKING_STATUSES);
                const bookingResponses = response.BookingResponses || [];
                const redirectTo = getBookRedirectUrl(bookingResponses);
                return tripBookingService.renderOtherFailedCases(response, tripId, tripDetails, redirectTo);
            }


            function issuesChecker(bookingResponses, status) {
                return bookingResponses.length && bookingResponses.every((value) => {
                    return !!value && value.BookingStatus === status;
                });
            }

            function getFunctionForGettingRedirectStateByBookingItems(listOfFailedItems) {
                return function(bookingItems) {
                    const firstFailedItem = _.find(bookingItems, (bookingItem) =>
                        listOfFailedItems.indexOf(bookingItem.BookingStatus) !== -1);

                    if (firstFailedItem) {
                        switch (firstFailedItem.TripItemType) {
                            case TRIP_ITEMS.CAR_TYPE_ITEM:
                                return 'main.cars';
                            case TRIP_ITEMS.HOTEL_TYPE_ITEM:
                                return 'main.hotels';
                            case TRIP_ITEMS.FLIGHT_TYPE_ITEM:
                                return 'main.flights.roundtrip';
                            case TRIP_ITEMS.RAIL_TYPE_ITEM:
                                return 'main.ukrail.roundtrip';
                        }
                    }

                    return flightStates.ROUNDTRIP;
                };
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/tripBookingModal.js